// Etichette dei round EMOM: unica fonte di verità per builder, libreria e
// vista atleta. Prima ogni superficie se le ricostruiva da sola e lo stesso
// round usciva "Min dispari" nel conditioning, "Round dispari" lato atleta e
// "Round 1" nel builder forza.
//
// La terminologia è "Round" e non "Min" perché l'intervallo non è per forza un
// minuto: con E2:00 o E3:00 "Min pari" descriverebbe la cosa sbagliata.

const WORDS = {
	it: {
		round: "Round",
		odd: "Round dispari",
		even: "Round pari",
		custom: "Personalizzato",
	},
	en: {
		round: "Round",
		odd: "Odd round",
		even: "Even round",
		custom: "Custom",
	},
};

const words = (language) => WORDS[language === "en" ? "en" : "it"];

/**
 * Solo l'assegnazione del round (pari/dispari/progressivo), senza il titolo
 * libero: per le viste che il titolo lo mostrano già per conto loro.
 */
export function getEmomRoundAssignmentLabel(round, index, language = "it") {
	const w = words(language);

	switch (round?.assignment_type) {
		case "odd":
			return w.odd;
		case "even":
			return w.even;
		case "specific":
			return round?.specific_minutes
				? `${w.round} ${round.specific_minutes}`
				: `${w.round} ${index + 1}`;
		case "custom":
			return w.custom;
		default:
			return `${w.round} ${index + 1}`;
	}
}

/**
 * Etichetta completa: assegnazione + eventuale titolo scritto dal coach.
 */
export function getEmomRoundLabel(round, index, language = "it") {
	const w = words(language);
	const title = (round?.label || round?.custom_label || "").trim();

	const label =
		round?.assignment_type === "custom"
			? title || `${w.round} ${index + 1}`
			: getEmomRoundAssignmentLabel(round, index, language);

	if (title && title !== label) {
		return `${label} - ${title}`;
	}
	return label;
}
